<template>
  <div>
    123456fasfa
    <div>
      <span v-for="(item,i) in list" :key="i">{{ item+'、' }}</span>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      list:[this.$t('tianTian'),this.$t('xiangShang'),this.$t('haoHao'),this.$t('xueXi')],
      list2:[this.$t('hao'),this.$t('fFaShengFaSa'),this.$t('faGa')],

    }
  }
}
</script>
